import { useEffect, useState } from "react";
import { InputDevice } from "./types";

export const useCurrentInputDevice = () => {
  const [device, setDevice] = useState<InputDevice>("mouse");

  useEffect(() => {
    const handleMouseMove = () => {
      setDevice("mouse");
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Tab") {
        setDevice("keyboard");
      }
    };

    document.addEventListener("mousedown", handleMouseMove);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseMove);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return {
    isKeyboard: device === "keyboard",
    isMouse: device === "mouse",
    setDevice,
  };
};
